<div class="agpr-performanceReport-mppAdjustedEstimates">
    <agpr-checkbox
        id="distributions_performance_enableMppEstimates"
        label="Discover.distribution.statistics.mppAdjustedEstimates"
        [binary]="true"
        [(ngModel)]="_enableMppEstimates"
        (ngModelChange)="changeMppEstimates()"
    >
        <a
            agprTooltip="Discover.distribution.statistics.mppAdjustedEstimates.info"
            [escape]="false"
            role="img"
            class="fa-regular fa-circle-info agpr-performanceReport-mppAdjustedEstimates-tooltip"
            [interactiveTooltip]="true"
            href="https://help.agilitypr.com/en/articles/6816484-agility-email-reporting-with-apple-mail-privacy-protection"
            target="_blank"
        ></a>
    </agpr-checkbox>
</div>

@if (isScheduled && (status === statisticsResourceStatus.scheduled || status ===
    statisticsResourceStatus.pending)) {
    <agpr-message [severity]="messageSeverities.info">
        {{
            (isDistribution
                ? "Discover.distributionReport.scheduledNotice"
                : "Discover.briefingReport.scheduledNotice"
            ) | localize
        }}{{ _sentDate | changeTimeZone : userTimeZone : "MMMM D, YYYY h:mm A z" }}
        @if (userTimeZone !== 'UTC') {
            {{ "(UTC" }}{{ _sentDate | changeTimeZone : userTimeZone : "Z)" }}
        }
    </agpr-message>
}

<!-- Placeholder while we wait for events to arrive -->
@if (!recipientReportData || status === statisticsResourceStatus.pending || isRSSFeed) {
    <div class="agpr-reportPlaceholder">
        <div class="agpr-reportPlaceholder-mainContainer">
            <span class="fa-duotone fa-regular fa-chart-line-up noContentIcon"
                  aria-hidden="true"
            ></span>
            @if (!isRSSFeed) {
                @if (status === statisticsResourceStatus.scheduled) {
                    <div>
                        @if (isDistribution) {
                            <div class="mainText">
                                {{
                                    "Discover.distributionReport.reportPlaceholder.unsent"
                                        | localize
                                }}
                            </div>
                            <div>
                                {{
                                    "Discover.distributionReport.reportPlaceholder.unsent.details"
                                        | localize
                                }}
                            </div>
                        } @else {
                            <div class="mainText">
                                {{
                                    "Discover.briefingsReport.reportPlaceholder.unsent"
                                        | localize
                                }}
                            </div>
                            <div>
                                {{
                                    "Discover.briefingsReport.reportPlaceholder.unsent.details"
                                        | localize
                                }}
                            </div>
                        }
                    </div>
                }
                @if (status !== statisticsResourceStatus.scheduled && !dataNotAvailable) {
                    <div>
                        <div class="mainText">{{ placeholderTitle | localize }}</div>
                        <div>
                            {{
                                "Discover.distributionReport.reportPlaceholder.sent.details"
                                    | localize
                            }}
                        </div>
                    </div>
                }
                @if (status !== statisticsResourceStatus.scheduled && dataNotAvailable) {
                    <div>
                        <div class="mainText">
                            {{
                                "Discover.distributionReport.reportPlaceholder.sent.details.dataNotAvailable"
                                    | localize
                            }}
                        </div>
                        <div class="subText">
                            {{
                                "Discover.distributionReport.reportPlaceholder.sent.details.dataNotAvailable.details"
                                    | localize
                            }}
                        </div>
                    </div>
                }
            }
            @if (isRSSFeed) {
                <div class="mainText">
                    {{ "Briefings.sentReport.rssFeed.noData" | localize }}
                </div>
            }
        </div>
    </div>
} @else {
    <!-- Actual report content -->
    <div class="agpr-performanceReport-totalDeliveredCard">
        <h4 class="agpr-performanceReport-totalDeliveredCard-heading">
            <span>
                {{
                    "Discover.distributionReport.recipient.section.totalDelivered"
                        | localize
                }}
            </span>
            <span>
                {{ recipientReportData.deliveredCount | number }} /
                {{ recipientReportData.sentCount | number }}
            </span>
        </h4>
    </div>
    @if (!openTracking) {
        <agpr-message [severity]="messageSeverities.info">
            <span>{{
                "Discover.distributionReport.tracking.openDisabled" | localize
            }}</span>
        </agpr-message>
    }
    @if (!clickTracking) {
        <agpr-message [severity]="messageSeverities.info">
            <span>{{
                "Discover.distributionReport.tracking.clickDisabled" | localize
            }}</span>
        </agpr-message>
    }
    <div class="agpr-performanceReport-summary-container">
        <agpr-performance-tracking-card
            [statType]="distributionStatTypes.UNIQUE_OPEN_RATE"
            [enableMppEstimates]="_enableMppEstimates"
            [trackingEnabled]="openTracking"
            [recipientReportData]="recipientReportData"
            [disabledTooltip]="
                'Discover.distributionReport.tracking.openDisabled'
            "
            [statisticReportSourceType]="statisticReportSourceType"
        ></agpr-performance-tracking-card>
        <agpr-performance-tracking-card
            [statType]="distributionStatTypes.UNIQUE_CLICK_RATE"
            [enableMppEstimates]="_enableMppEstimates"
            [trackingEnabled]="clickTracking"
            [recipientReportData]="recipientReportData"
            [disabledTooltip]="
                'Discover.distributionReport.tracking.clickDisabled'
            "
            [statisticReportSourceType]="statisticReportSourceType"
        ></agpr-performance-tracking-card>
    </div>

    <div class="agpr-performanceReport-chart-container" role="group">
        <h5 class="agpr-performanceReport-chart-header">
            {{
                "Discover.distributionReport.performance.chartHeader" | localize
            }}
        </h5>
        <agpr-tabs
            class="agpr-performanceReport-chart-tabs"
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="chartTabChange($event)"
            [tabsHeadingLevel]="6"
        >
            <agpr-tab
                heading="Discover.distributionReport.performance.chart24h"
                [id]="'distributionReport.chart24hTab'"
            >
            </agpr-tab>
            <agpr-tab
                heading="Discover.distributionReport.performance.chart7d"
                [disabled]="!lineChart"
                [id]="'distributionReport.chart7dTab'"
            >
            </agpr-tab>
        </agpr-tabs>
        @if (lineChart) {
            <agpr-chart [chart]="lineChart"></agpr-chart>
        }
        @if (!lineChart) {
            <div class="agpr-performanceReport-chart-noContent">
                {{ "Common.noContentToDisplay" | localize }}
            </div>
        }
    </div>

    @if (linksReport) {
        <div class="agpr-performanceReport-linksReport-container">
            <div class="agpr-performanceReport-linksReport-header" role="group">
                <h5
                    class="agpr-performanceReport-linksReport-headerLabels agpr-performanceReport-linksReport-row"
                >
                    <span>{{
                        "Discover.distributionReport.performance.links.linksClicked"
                            | localize
                    }}</span>
                    <span>{{
                        "Discover.distributionReport.performance.links.clicked"
                            | localize
                    }}</span>
                    <span>
                        {{
                            "Discover.distributionReport.performance.links.ctr"
                                | localize
                        }}
                        @if (_enableMppEstimates) {
                            <span
                                class="agpr-performanceReport-linksReport-header-estimated"
                            >
                                ({{
                                    "Discover.distribution.statistics.estimated"
                                        | localize
                                }})
                            </span>
                        }
                        <span
                            role="img"
                            class="fa-regular fa-circle-info"
                            [agprTooltip]="ctrTooltipString"
                            [escape]="false"
                        ></span>
                    </span>
                </h5>
                <div
                    class="agpr-performanceReport-linksReport-headerNumbers agpr-performanceReport-linksReport-row"
                >
                    @if (!clickTracking) {
                        <span
                            class="agpr-performanceReport-linksReport-na"
                            [pTooltip]="
                                'Discover.distributionReport.tracking.clickDisabled'
                                    | localize
                            "
                            tooltipPosition="left"
                        >
                            {{ "N/A" | localize }}
                        </span>
                    }
                    @if (clickTracking) {
                        <span>
                            {{ linksReport.linkStats.length | number }}
                        </span>
                    }

                    @if (!clickTracking) {
                        <span
                            class="agpr-performanceReport-linksReport-na agpr-performanceReport-linksReport-clicksValue"
                            [pTooltip]="
                                'Discover.distributionReport.tracking.clickDisabled'
                                    | localize
                            "
                        >
                            {{ "N/A" | localize }}
                        </span>
                    } @else {
                        <span class="agpr-performanceReport-linksReport-clicksValue">
                            {{ linksReport.totalClicks | number }}
                        </span>
                    }

                    @if (!openTracking || !clickTracking) {
                        <span
                            class="agpr-performanceReport-linksReport-na"
                            [pTooltip]="
                                !clickTracking
                                    ? ('Discover.distributionReport.tracking.clickDisabled'
                                      | localize)
                                    : ('Discover.distributionReport.tracking.openDisabled'
                                      | localize)
                            "
                        >
                            {{ "N/A" | localize }}
                        </span>
                    }
                    @if (openTracking && clickTracking) {
                        <span>
                            {{ linksReport.totalClickThroughRate | percent : "1.1-1" }}
                        </span>
                    }
                </div>
            </div>

            @if (clickTracking) {
                @for (linkStat of linksReport.linkStats; track linkStat.url) {
                    <div
                        class="agpr-performanceReport-linksReport-row agpr-performanceReport-linksReport-row-selectable"
                        (agprClickUnless)="selectLink(linkStat.url)"
                        [agprClickUnlessSelectors]="clickUnlessSelectors"
                        [ngClass]="{
                            'agpr-performanceReport-linksReport-row-selected':
                                selectedLink === linkStat.url
                        }"
                    >
                        @if (!clickTracking) {
                            <span
                                class="agpr-performanceReport-linksReport-na"
                                [pTooltip]="
                                    'Discover.distributionReport.tracking.clickDisabled'
                                        | localize
                                "
                            >
                                {{ "N/A" | localize }}
                            </span>
                        }
                        @if (clickTracking) {
                            <span>
                                <a
                                    class="agpr-performanceReport-linksReport-row-url"
                                    [ngClass]="{
                                        'agpr-performanceReport-linksReport-row-url-selected':
                                            selectedLink === linkStat.url
                                    }"
                                    [href]="linkStat.url"
                                    target="_blank"
                                >
                                    {{ linkStat.url }}
                                </a>
                            </span>
                        }

                        @if (!clickTracking) {
                            <span
                                class="agpr-performanceReport-linksReport-na agpr-performanceReport-linksReport-clicksValue"
                                [pTooltip]="
                                    'Discover.distributionReport.tracking.clickDisabled'
                                        | localize
                                "
                            >
                                {{ "N/A" | localize }}
                            </span>
                        } @else {
                            <span class="agpr-performanceReport-linksReport-clicksValue">
                                {{ linkStat.clickCount | number }}
                            </span>
                        }

                        @if (!openTracking || !clickTracking) {
                            <span
                                class="agpr-performanceReport-linksReport-na"
                                [pTooltip]="
                                    !openTracking
                                        ? ('Discover.distributionReport.tracking.openDisabled'
                                          | localize)
                                        : ('Discover.distributionReport.tracking.clickDisabled'
                                          | localize)
                                "
                            >
                                {{ "N/A" | localize }}
                            </span>
                        }
                        @if (openTracking && clickTracking) {
                            <span>
                                {{ linkStat.clickThroughRate | percent : "1.1-1" }}
                            </span>
                        }
                    </div>
                }
            }
            @if (!clickTracking) {
                <div class="agpr-performanceReport-linksReport-row-noContent">
                    <agpr-message [severity]="messageSeverities.noContent">
                        <span>{{
                            "Discover.distributionReport.performance.noData" | localize
                        }}</span>
                    </agpr-message>
                </div>
            }
        </div>
    }
}
